import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { getNotifications } from '../../../actions/Notifications';
import LoginService from '../../../services/LoginService';
import CONSTANTS from '../../../constants';

import '../../../assets/css/notifications.scss';

class NotificationIcon extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentDidMount() {
    let tokenInfo = LoginService.getToken();
    if (tokenInfo && tokenInfo.userId) this.props.getNotifications(tokenInfo.userId);
  }

  goToNotificationsList() {
    this.props.history.push(`${CONSTANTS.BASE_URL}notifications`, {
      notifications: this.props.notifications
    });
  }

  render() {
    const { notifications } = this.props;
    if (notifications && notifications.length > 0) {
      let unseenNotifications = notifications.filter((notification) => {
        return notification.status === CONSTANTS.NOTIFICATIONS.VARIABLES.SEEN_STATUS.UNSEEN;
      });
      return (
        <div className="notifications align-self-baseline cursor" style={{ height: '60px' }}>
          <span className="bell-icon" onClick={this.goToNotificationsList.bind(this)}>
            <FontAwesomeIcon
              icon={faBell}
              size={'2x'}
              color={this.props.locationSettings?.basecolor}
            />
            {unseenNotifications.length > 0 && (
              <div className="counter">
                <span className="badge badge-danger">{unseenNotifications.length}</span>
              </div>
            )}
          </span>
        </div>
      );
    }
    return '';
  }
}

function mapStateToProps(state) {
  const { notifications, locationSettings } = state;
  return { notifications, locationSettings };
}

export default connect(mapStateToProps, { getNotifications })(withRouter(NotificationIcon));
